import store from '../store/store'
import responsableFacturacionImpuestos from './auth/responsable_facturacion_impuestos';
import asistenteAdministracion from './auth/asistente_administracion';
import disenio from './auth/disenio';
import produccion from './auth/produccion';
import asistenteProduccion from './auth/asistente_produccion';
import directorEjecutivo from './auth/director_ejecutivo';
import ejecutivoComercial from './auth/ejecutivo_comercial';
import asistenteComercial from './auth/asistente_comercial';
import coordinadorComercial from './auth/coordinador_comercial';
import gerenteComercial from './auth/gerente_comercial';
import responsableFinanzasProveedores from './auth/responsable_finanzas_proveedores';
import recepcion from './auth/recepcion';
import asistenteLogistica from './auth/asistente_logistica';
import rrhh from './auth/rrhh';
import cuentas from './auth/cuentas';
import promociones from './auth/promociones';
import asistenteCalidad from './auth/asistente_calidad';
import coordinadorDisenio from './auth/coordinador_disenio';

export function getAccesos() {
    let accesos = [];

    switch (store.getters['user/rolId']) {
        case 1: /* Superadministrador */ 
        case 2: /* Direccion */
        case 6: /* Director Administrativo */
        case 8: /* Calidad */
            break;
        
        case 3: /* Cuentas */ 
        case 13: /* Asistente de cuentas */
            accesos = cuentas.accesos;
            break;

        case 12: /* Asistente de promociones */
        case 15: /* Coordinador/a de promociones */
            accesos = promociones.accesos;
            break;

        case 4: /* Produccion */
              accesos = produccion.accesos;
              break;

        case 14: /* Asistente de produccion */
            accesos = asistenteProduccion.accesos;
            break;

        case 5: /* Diseño */
            accesos = disenio.accesos;
            break;

        case 7: /* Asistente de Administracion */
            accesos = asistenteAdministracion.accesos;
            break;

        case 9: /* Director Ejecutivo */ 
            accesos = directorEjecutivo.accesos;
            break;

        case 10: /* Asistente de Logistica */
            accesos = asistenteLogistica.accesos;
            break;

        case 11: /* RRHH */ 
            accesos = rrhh.accesos;
            break;
        
        case 16: /* Ejecutivo comercial */
            accesos = ejecutivoComercial.accesos;
            break;

        case 17: /* Asistente comercial */
            accesos = asistenteComercial.accesos;
            break;

        case 18: /* Recepcion */ 
            accesos = recepcion.accesos;
            break;

        case 19: /* Coordinador/a comercial */
            accesos = coordinadorComercial.accesos;
            break;

        case 20: /* Gerente comercial */
            accesos = gerenteComercial.accesos;
            break;

        case 21: /* Responsable de Finanzas y Proveedores */ 
            accesos = responsableFinanzasProveedores.accesos;
            break;

        case 22: /* Responsable de Facturacion e Impuestos */
            accesos = responsableFacturacionImpuestos.accesos;
            break;

        case 23: /* Asistente Calidad */
            accesos = asistenteCalidad.accesos;
            break;

        case 24: /* Coordinador Diseño */
            accesos = coordinadorDisenio.accesos;
            break;
    }

    /* Accesos disponibles para todos los usuarios */
    accesos.push({ route: '/', modulo: '' });
    accesos.push({ route: 'perfil', modulo: '' });
    accesos.push({ route: 'pwd', modulo: '' });
    accesos.push({ route: 'seguridad/usuarios/self-pass', modulo: '' });

    return accesos;
}
